
class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);

        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        document.addEventListener('variant:changed:gtm', this.handleVariantChange.bind(this));
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleVariantChange(event) {
       
        const data = JSON.parse(
            document.querySelector('product-component script[type="application/ld+json"]').textContent
        );
        data.ecommerce.items[0].item_variant = event.detail.title || "Default Title";
        data.ecommerce.items[0].item_id = event.detail.sku || "";
        data.ecommerce.items[0].item_sku = event.detail.sku || "";
        data.ecommerce.items[0].price = event.detail.price / 100;
        

        const quantity = parseInt(document.querySelector('.pm__quantity-input')?.value) || 1;

        data.ecommerce.items[0].quantity = quantity;
        data.ecommerce.value = event.detail.price / 100 * quantity;
        if (!dataLayer || !data) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);

        console.log(data, "And pushed to dataLayer");
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

                console.log(entry, "observed");

                if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                console.log(data, "And pushed to dataLayer");
            }
        });
    }


    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;
    
        window.fetch = async function (...args) {
            let [url, options] = args;
            let capturedRequestDataForEvent = null;
    
            try {
                if (url.includes(`/cart/add.js`) && options && options.body) {
                    if (options.body instanceof FormData) {
                        capturedRequestDataForEvent = {
                            id: options.body.get('id'),
                            quantity: options.body.get('quantity'),
                            category: options.body.get('category'),
                            category2: options.body.get('category2'),
                            list_id: options.body.get('list_id'),
                            list_name: options.body.get('list_name'),
                        };
    
                        const category = capturedRequestDataForEvent.category;
                        const category2 = capturedRequestDataForEvent.category2;
                        const list_id = capturedRequestDataForEvent.list_id;
                        const list_name = capturedRequestDataForEvent.list_name;
    
                        if (category) {
                            options.body.append('properties[_category]', category);
                        }
                        if (category2) {
                            options.body.append('properties[_category2]', category2);
                        }
                        if (list_id) {
                            options.body.append('properties[_list_id]', list_id);
                        }
                        if (list_name) {
                            options.body.append('properties[_list_name]', list_name);
                        }
                    } else if (typeof options.body === 'string') {
                         const contentType = options.headers ? (options.headers['Content-Type'] || options.headers['content-type']) : null;
                         if (contentType && contentType.includes('application/json')) {
                            try {
                                let requestPayload = JSON.parse(options.body);
                                capturedRequestDataForEvent = {
                                    id: requestPayload.id,
                                    quantity: requestPayload.quantity,
                                    category: requestPayload.category,
                                    category2: requestPayload.category2,
                                    list_id: requestPayload.list_id,
                                    list_name: requestPayload.list_name,
                                };
    
                                if (requestPayload && (
                                    capturedRequestDataForEvent.category ||
                                    capturedRequestDataForEvent.category2 ||
                                    capturedRequestDataForEvent.list_id ||
                                    capturedRequestDataForEvent.list_name
                                    )) {
    
                                    requestPayload.properties = requestPayload.properties || {};
                                    if (capturedRequestDataForEvent.category) {
                                        requestPayload.properties['_category'] = capturedRequestDataForEvent.category;
                                    }
                                    if (capturedRequestDataForEvent.category2) {
                                        requestPayload.properties['_category2'] = capturedRequestDataForEvent.category2;
                                    }
                                    if (capturedRequestDataForEvent.list_id) {
                                        requestPayload.properties['_list_id'] = capturedRequestDataForEvent.list_id;
                                    }
                                    if (capturedRequestDataForEvent.list_name) {
                                        requestPayload.properties['_list_name'] = capturedRequestDataForEvent.list_name;
                                    }
    
                                    options.body = JSON.stringify(requestPayload);
                                    if (options.headers && (options.headers['Content-Length'] || options.headers['content-length'])) {
                                        options.headers['Content-Length'] = new TextEncoder().encode(options.body).length.toString();
                                    }
                                }
                            } catch (e) {
                                console.warn('Fetch interceptor: Failed to parse/modify assumed JSON body for /cart/add.js', e);
                            }
                        }
                    }
                }
    
                if (url.includes(`/cart/clear.js`)) _this.cartClear();
    
                const response = await originalFetch.apply(this, args);
                const originalResponse = response;
                const responseClone = response.clone();
    
                if (!responseClone.ok) {
                     console.warn(`Workspace interceptor: Request to ${url} failed with status ${responseClone.status}`);
                    return originalResponse;
                }
    
                 if (
                     url === '' ||
                     typeof dataLayer === 'undefined' ||
                     !(
                         url.includes(`/cart/add.js`) ||
                         url.includes(`/cart/change.js`) ||
                         url.includes(`/cart/update.js`)
                     )
                 ) {
                     return originalResponse;
                 }
    
                let json = null;
                try {
                     json = await responseClone.json();
                } catch (e) {
                    console.error('Fetch interceptor: Failed to parse JSON response from cart API', e, await responseClone.text());
                    return originalResponse;
                }
    
                if (url.includes(`/cart/add.js`)) {
                    _this.cartAdd(json, capturedRequestDataForEvent);
                } else if (url.includes(`/cart/change.js`) || url.includes(`/cart/update.js`)) {
                    _this.cartUpdate(json);
                }
    
                return originalResponse;
    
            } catch (e) {
                console.error('Fetch interceptor critical error:', e);
                return originalFetch(...args);
            }
        };
    }

    async cartAdd(cart, requestPayload) {
        cart.items ? this.productAdded(cart.items, requestPayload) : this.productAdded([cart], requestPayload);
    }

    async cartUpdate(cart) {
        this.productAdded(cart.items_added);
        this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    async productAdded(cartItems, requestPayload) {
        if (!cartItems || !cartItems.length) return;

        const items = [];
        let totalPrice = 0;
    
        // Use a for...of loop to allow awaiting inside the loop
        for (const item of cartItems) {
            console.log('item', item);
            totalPrice += item.price / 100;

            console.log('requestPayload', requestPayload);
            
            items.push({
                'item_sku': item.sku,
                'item_id': item.sku,
                'id': item.id.toString(),
                'item_name': item.untranslated_product_title,
                'item_brand': item.vendor.replace('®', '').trim(),
                'item_category': requestPayload.category,
                'item_category2': requestPayload.category2,
                'item_list_id': requestPayload.list_id,
                'item_list_name': requestPayload.list_name,
                'item_variant': item.untranslated_variant_title || "Default Title",
                'discount': item.total_discount / 100,
                'price': item.presentment_price,
                'quantity': parseInt(requestPayload.quantity),
                'google_business_vertical': "retail"
            });
        }
    
        const pushData = {
            'event': 'Add To Cart',
            'ecommerce': {
                'value': totalPrice,
                'currency': window.Shopify.currency.active,
                'items': items
            }
        };
        dataLayer.push({ ecommerce: null });
        dataLayer.push(pushData);
    
        console.log("dataLayer push -> added:", pushData);
    }
    

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const items = [];
        let totalPrice = 0;

        cartItems.forEach(item => {
            const price = Shopify.formatMoney(item.price, '{{amount}}');
            totalPrice += price;

            items.push({
                'item_id': item.sku,
                'item_variant': item.variant_title,
                'item_name': item.product_title,
                'price': price,
                'quantity': parseInt(item.quantity)
            })
        })

        dataLayer.push({
            event: "remove_from_cart",
            remove: {
                value: totalPrice,
                items: items
            },
        });

        console.log("dataLayer push -> removed:", items);
    }


    handleSelectItem(event) {
        let target = event.target.closest('[data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        dataLayer.push({
            event: "select_item",
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            selected_items: [
                {
                    item_id: settings.item_id,
                    item_name: settings.item_name,
                    price: settings.price,
                    item_list_id: settings.list_id,
                    item_list_name: settings.list_name,
                },
            ],
        });
    }
}

new gTagEvents();